"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallState = exports.connectWeixinJSBridge = exports.VOOV_PACKAGE_NAME = exports.PACKAGE_NAME = void 0;
/**
 * 腾讯会议应用包名
 */
exports.PACKAGE_NAME = 'com.tencent.wemeet.app';
exports.VOOV_PACKAGE_NAME = 'com.tencent.voov';
/**
 * 微信JS-SDK: https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
 */
var connectWeixinJSBridge = function () { return new Promise(function (resolve) {
    if (window.WeixinJSBridge) {
        resolve(window.WeixinJSBridge);
    }
    else {
        document.addEventListener('WeixinJSBridgeReady', function (res) {
            console.log('>>> WeixinJSBridgeReady:', res);
            resolve(window.WeixinJSBridge);
        });
    }
}); };
exports.connectWeixinJSBridge = connectWeixinJSBridge;
/**
 * 检查微信下是否安装应用
 * @param {*} packageName
 * @param {*} platform - android or iphone
 */
var getInstallState = function (platform, packageName, isVoov) {
    if (platform === void 0) { platform = 'android'; }
    console.log('>>> getInstallState:', packageName);
    var pkgName = isVoov ? exports.VOOV_PACKAGE_NAME : exports.PACKAGE_NAME;
    return new Promise(function (resolve) {
        (0, exports.connectWeixinJSBridge)().then(function (WeixinJSBridge) {
            var param = {};
            if (platform === 'iphone') {
                param = {
                    packageUrl: (packageName || 'wemeet://'),
                };
            }
            else {
                param = {
                    packageName: (packageName || pkgName),
                };
            }
            WeixinJSBridge.invoke('getInstallState', param, function (res) {
                console.log('>>> getInstallState:', res);
                resolve(res);
            });
        });
    });
};
exports.getInstallState = getInstallState;
//# sourceMappingURL=tx-weixin-jsbridge.js.map